(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wodemax-sales-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sales-contact]').forEach((center) => {
    const wrapper = center.querySelector('[data-sales-form-wrapper]');
    const select = center.querySelector('[data-inquiry-select]');
    const cards = Array.from(center.querySelectorAll('[data-inquiry-type]'));
    const productField = center.querySelector('[data-sales-field="product"]');
    const quantityField = center.querySelector('[data-sales-field="quantity"]');
    const customizationField = center.querySelector('[data-sales-field="customization"]');
    const websiteField = center.querySelector('[data-sales-field="website"]');
    const channelsField = center.querySelector('[data-sales-field="channels"]');

    if (!wrapper || !select) return;

    if (!wrapper.querySelector('[data-sales-success]')) {
      sessionStorage.removeItem('wodemax-sales-conversion-tracked');
    }

    const updateFields = (value) => {
      const isProductInquiry = value === 'sales' || value === 'oem';
      const isOem = value === 'oem';
      const isDistributor = value === 'distributor';

      if (productField) productField.hidden = !isProductInquiry;
      if (quantityField) quantityField.hidden = !isProductInquiry;
      if (customizationField) customizationField.hidden = !isOem;
      if (websiteField) websiteField.hidden = !isDistributor;
      if (channelsField) channelsField.hidden = !isDistributor;

      cards.forEach((card) => {
        card.setAttribute('aria-pressed', String(card.dataset.inquiryType === value));
      });
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        select.value = card.dataset.inquiryType;
        updateFields(select.value);
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    select.addEventListener('change', () => updateFields(select.value));

    const requestedType = new URLSearchParams(window.location.search).get('inquiry');
    const validTypes = Array.from(select.options).map((option) => option.value);
    if (requestedType && validTypes.includes(requestedType)) {
      select.value = requestedType;
    }

    updateFields(select.value);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wodemax-support-center"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-support-center]').forEach((center) => {
    const form = center.querySelector('[data-support-form]');
    const select = center.querySelector('[data-support-select]');
    const cards = Array.from(center.querySelectorAll('[data-support-request]'));
    const productField = center.querySelector('[data-support-field="product"]');
    const orderField = center.querySelector('[data-support-field="order"]');
    const categoryField = center.querySelector('[data-support-field="category"]');
    const mediaField = center.querySelector('[data-support-field="media"]');
    const categorySelect = categoryField ? categoryField.querySelector('select') : null;

    if (!form || !select) return;

    const updateFields = (value) => {
      const needsProduct = ['technical_support', 'warranty', 'rma', 'feedback'].includes(value);
      const needsOrder = ['warranty', 'rma', 'feedback'].includes(value);
      const isFeedback = value === 'feedback';

      if (productField) productField.hidden = !needsProduct;
      if (orderField) orderField.hidden = !needsOrder;
      if (categoryField) categoryField.hidden = !isFeedback;
      if (mediaField) mediaField.hidden = !isFeedback;
      if (categorySelect) categorySelect.required = isFeedback;

      cards.forEach((card) => {
        card.setAttribute('aria-pressed', String(card.dataset.supportRequest === value));
      });
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        select.value = card.dataset.supportRequest;
        updateFields(select.value);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    select.addEventListener('change', () => updateFields(select.value));

    const requestedType = new URLSearchParams(window.location.search).get('request');
    const validTypes = Array.from(select.options).map((option) => option.value);
    if (requestedType && validTypes.includes(requestedType)) {
      select.value = requestedType;
    }

    updateFields(select.value);
  });

  } catch(e) { console.error(e); }
})();
})();
